import type { AutotaskConfig, Picklist } from '@/hooks/usePsa.ts';
import { picklistOptions } from './psaSettings.ts';

/**
 * The settings form's starting draft: the stored settings, with who may see notes
 * preselected on the option whose label says "internal" when none is chosen yet.
 * Notes are internal unless the admin chooses otherwise (decision 4); the admin
 * sees the choice and saves it.
 */
export function initialDraft(config: AutotaskConfig, picklists: Picklist[] | undefined): AutotaskConfig {
  if (config.note_publish != null) return config;
  const internal = picklistOptions(picklists, 'publish').find((o) => o.active && /internal/i.test(o.label));
  return internal ? { ...config, note_publish: Number(internal.value) } : config;
}
